import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createEventModalDataClear,
  createEventModalDataSaver,
  getEventCategory,
  getEventNames,
  getStaffDetails,
} from "../store/slices/Project/ProjectSingle";
import { saveStudioAsStaff } from "../store/slices/Staffs/staffsSlice";

export const useAddNewFolder = () => {
  const dispatch = useDispatch();
  const [customFieldName, setCustomFieldName] = useState(false);

  const { createNewFolder, allFolders, eventModalData } = useSelector(
    (state) => state.projectSinglePage
  );
  const { status: addStaffStatus } = useSelector(
    (state) => state.preferenceList
  );
  const { staffSkipStatus } = useSelector((state) => state.staffs);
  const [skipStatus, setSkipStatus] = useState(false);
  useEffect(() => {
    // getAllStaffs();
    if (createNewFolder?.staffList?.length === 0) {
      getAllStaffs();
    }

    if (createNewFolder?.eventCategories.length === 0) {
      getAllEventCategories();
    }

    if (createNewFolder?.events.length === 0) {
      getAllEvents();
    }
    if (eventModalData?.customName || initialInput?.customName) {
      setCustomFieldName(true);
    }
    return () => {
      // dispatch(resetStaffArray());
    };
  }, []);

  const [initialInput, setInitialInputs] = useState({
    eventName: Number.isInteger(allFolders?.editFolder?.details?.album_name_id)
      ? allFolders?.editFolder?.details?.album_name_id
      : allFolders?.editFolder?.status === true
      ? "custom"
      : eventModalData?.eventName ?? "",
    location:
      allFolders?.editFolder?.status === true
        ? allFolders?.editFolder?.details?.location_name
        : eventModalData?.location ?? "",
    date:
      allFolders?.editFolder?.status === true
        ? allFolders?.editFolder?.details?.date
        : eventModalData?.date ?? "",
    eventCategory:
      allFolders?.editFolder?.status === true
        ? allFolders?.editFolder?.details?.event_category_id
        : eventModalData?.eventCategory ?? "",
    customName:
      allFolders?.editFolder?.status &&
      Number.isInteger(allFolders?.editFolder?.details?.album_name_id) === false
        ? allFolders?.editFolder?.details?.name
        : eventModalData?.customName ?? "",
    staff:
      allFolders?.editFolder?.status === true
        ? allFolders?.editFolder?.details?.staffIDs
        : eventModalData?.staff ?? "",
  });
  useEffect(() => {
    if (
      allFolders?.editFolder?.status === true &&
      allFolders?.editFolder?.details?.album_name_id !== undefined &&
      allFolders?.editFolder?.details?.album_name_id !== null
    ) {
      if (
        allFolders?.editFolder?.status === true &&
        Number.isInteger(
          allFolders?.editFolder?.details?.album_name_id === true
        )
      ) {
        // setCustomFieldName(false);
      } else {
        // setCustomFieldName(true);
      }
    } else {
      if (!allFolders?.editFolder?.status) {
        // setCustomFieldName(true);
      } else if (allFolders?.editFolder?.status === true) {
        // setCustomFieldName(false);
      }
    }

    return () => {
      // setCustomFieldName(false);
    };
  }, [allFolders?.editFolder?.details?.album_name_id]);
  const getSelectedEventCategory = (createNewFolder) => {
    try {
      return createNewFolder?.eventCategories?.filter((option) => {
        return (
          allFolders?.editFolder?.details?.event_category?.id === option.value
        );
      })?.[0];
    } catch (error) {
      return false;
    }
  };

  const getSelectedStaffsArray = () => {
    let starray = "";
    if (createNewFolder.staffList.length > 0) {
      starray = createNewFolder.staffList?.filter((item) => {
        return allFolders?.editFolder?.details?.staffIDs?.includes(item.value);
      });
    }
    return starray;
  };

  const getAllStaffs = () => {
    return dispatch(getStaffDetails());
  };

  const getAllEventCategories = () => {
    return dispatch(getEventCategory());
  };

  const getAllEvents = () => {
    return dispatch(getEventNames());
  };

  const capitalizeFirstLetter = (s) => s && s[0].toUpperCase() + s.slice(1);

  const [staffStatus, setStafStatus] = useState(false);

  const handleSkipStaff = () => {
    setSkipStatus(true);
  };

  const handleCreateNewFolder = () => {
    dispatch(saveStudioAsStaff());
  };

  const handleSaveEventCreateModalData = async (values) => {
    const resultAction = await dispatch(createEventModalDataSaver(values));
    if (createEventModalDataSaver.fulfilled.match(resultAction)) {
      dispatch(getStaffDetails());
    }
  };

  const handleClearEventCreateData = () => {
    setCustomFieldName(false);
    dispatch(createEventModalDataClear());
  };

  return {
    initialInput,
    setInitialInputs,
    customFieldName,
    setCustomFieldName,
    getSelectedEventCategory,
    getSelectedStaffsArray,
    capitalizeFirstLetter,
    createNewFolder,
    allFolders,
    handleSkipStaff,
    skipStatus,
    staffSkipStatus,
    handleCreateNewFolder,
    handleSaveEventCreateModalData,
    handleClearEventCreateData,
    eventModalData,
    addStaffStatus,
  };
};
